videojs.addLanguage('en', {
	"Skip after": "Skip after",
	"Skip advertisement": "Skip",
	"Advertisement": "Advertisement",
	"Go to the advertiser's site": "Go to advertiser's site"
});